(ns frontend.ui.component.lp-portal.report.body.invest-europe.fund.pdf
  (:require
   [frontend.ui.component.lp-portal.report.body.invest-europe.fund.pdf-pages.fund-information :as fund-information]))

(defn invest-europe-pages
  [data]
  (concat
   [(fund-information/fund-information-page data)]))
